import { CountdownResult } from '@/types';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const isUnder10Min = (countdown: CountdownResult): boolean => {
  return (
    !countdown.expired && countdown.days === 0 && countdown.hours === 0 && countdown.minutes < 10
  );
};
